import { GamesSlidersConfig, SliderGamesConfig, GameTypesEnum } from './slider.models';

export const slidersConfig: GamesSlidersConfig = {
  [GameTypesEnum.Basic]: {
    title: 'browseAll',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: false,
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.Featured]: {
    title: 'featured',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: false,
      ranking: false,
      min_width: 304,
      ideal_width: 360,
      max_width: 603,
      spacer: 8,
      every: 1,
    },
  },
  [GameTypesEnum.PlayAgain]: {
    title: 'playAgain',
    config: {
      playBtn: true,
      infoBtn: true,
      browseAll: false,
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.NewGames]: {
    title: 'newToSkol',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=new',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.Top5]: {
    title: 'top5',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: false,
      ranking: false,
      min_width: 200,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 1,
    },
  },
  [GameTypesEnum.Recommended]: {
    title: 'recommended',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?type=recommended',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.BecauseYouPlayed]: {
    title: 'becauseYouPlayed',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: false,
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.Provider]: {
    title: 'providerGames',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.BecauseYouPlayedFromCurrentGame]: {
    title: 'becauseYouPlayedFromCurrentGame',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: false,
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.ProviderFromCurrentGame]: {
    title: 'moreInfo',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.Favorites]: {
    title: 'myGames',
    config: {
      playBtn: true,
      infoBtn: true,
      browseAll: true,
      browseAllLink: '/games?type=mygames',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.Jackpots]: {
    title: 'jackpots',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?type=jackpots',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.TableGames]: {
    title: 'tableGames',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=classic',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 3,
    },
  },
  [GameTypesEnum.LiveGames]: {
    title: 'liveGames',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=live',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.Megaways]: {
    title: 'megaways',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=megaways',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.MustGoJackpots]: {
    title: 'mustgojackpots',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=mustgojackpots',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.DropsAndWins]: {
    title: 'dropsandwins',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=dropsandwins',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.Slots]: {
    title: 'slots',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=slots',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.Fun]: {
    title: 'fun',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=fun',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.Popular]: {
    title: 'all',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=all',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.StickyWilds]: {
    title: 'stickyWilds',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=stickywilds',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
  [GameTypesEnum.Providers]: {
    title: 'providers',
    config: {
      playBtn: false,
      infoBtn: false,
      browseAll: true,
      browseAllLink: '/games?cat=providers',
      ranking: false,
      min_width: 96,
      ideal_width: 360,
      max_width: 400,
      spacer: 8,
      every: 0,
    },
  },
};

export const slidersGames: SliderGamesConfig = {
  jackpots: ['RTNEONLINKS', 'BPFISHINFRENZYMEGAWAYSJACKPOTKING', 'MGBLAZINGDIAMONDSWOWPOTS', 'MGIMMORTALROMANCEMEGAMOOLAH', 'RTJOEEXOTIC', 'RTREELKINGMEGA', 'BPBUFFALORISINGJACKPOTKING'],
  megaways: ['1X2SKOLBRANDEDMEGAWAYS', '1X2ROCKTHEREELSMEGAWAYS', 'BPEYEOFHORUSMEGAWAYS', 'NYXCENTURIONMEGAWAYS', 'RTPIRATESPLENTYMEGAWAYS', 'RTGONZOSQUESTMEGAWAYS', 'PMBUFFALOKINGMEGAWAYS'],
  newToSkol: ['1X2SKOLBRANDEDMEGAWAYS', 'NYXJUNGLEFALLS', 'PNGHOTELYETIWAY', 'RLXDEEPDESCENT', 'NYXHOTJOKER4WAYS', 'MGBIGBADBEAST', 'PNGZZTOPROADSIDERICHES'],
  liveGames: ['EVROULETTE', 'PMROULETTE', 'EVCRAZYTIME', 'PMGAMESSHOWSLOBBY', 'EVMONOPOLY', 'EVDEALORNODEAL', 'EVBLACKJACK'],
  tableGames: ['MGBACKBLACKJACK', 'EVLIGHTNINGROULETTEFIRSTPERSON', 'NYX20PROULETTE', 'RLXROULETTENOUVEAU', 'NYXBLACKJACKXCHANGE', 'RLX100BITDICE', 'EVFIRSTPERSONMEGABALL']
}
